@if ((!isSuccess() && !isError()) || isLoading()) {
  <div class="skeleton-item-list">
    @for (i of [].constructor(5); track $index) {
      <div class="skeleton-item"></div>
    }
  </div>
} @else if (isError() || !timeSlots()?.length) {
  <sd-system-message type="warning">
    {{ errorMessage }}
  </sd-system-message>
} @else {
  @if (timeSlots(); as timeSlots) {
    <div class="dates-block">
      <div class="checkout-section-title">
        <h2 class="mb-0 text-b3-m-700 text-md-b1-s-700 text-lg-b1-m-700 color-black">день</h2>

        <sd-checkout-validation-error [errorKeys]="['TIME_SLOT_REQUIRED']"></sd-checkout-validation-error>
      </div>

      <sd-time-slot-dates
        [timeSlots]="timeSlots"
        [selectedTimeSlot]="selectedTimeSlot()"
        [selectedDate]="selectedTimeSlotDate()"
        [selectedAnotherDate]="selectedTimeSlotAnotherDate()"
        (selectedDateChange)="onSelectedDateChange($event)"
        (selectedAnotherDateChange)="onSelectedAnotherDateChange($event)"
      ></sd-time-slot-dates>
    </div>

    @if (selectedTimeSlotAnotherDate() === selectedTimeSlotDate() && !selectedTimeSlot()) {
      @if (customDateIsLoading()) {
        <div class="skeleton-item-list">
          @for (i of [].constructor(5); track $index) {
            <div class="skeleton-item"></div>
          }
        </div>
      } @else if (customDateIsError()) {
        <sd-system-message type="warning">
          {{ errorMessage }}
        </sd-system-message>
      }
    }

    @if (selectedTimeSlot(); as selectedTimeSlot) {
      <div class="times-block">
        <h2 class="mb-0 text-b3-m-700 text-md-b1-s-700 text-lg-b1-m-700 color-black">время</h2>
        <sd-time-slot-groups
          [selectedTimeSlot]="selectedTimeSlot"
          [selectedGroupName]="selectedGroupName()"
          (selectedGroupNameChange)="onSelectedGroupChange($event)"
        ></sd-time-slot-groups>
      </div>

      @if (selectedGroup(); as selectedGroup) {
        <sd-time-slot-options
          [selectedGroup]="selectedGroup"
          [selectedOption]="selectedOption()"
          (selectedOptionChange)="onSelectedOptionChange($event)"
        ></sd-time-slot-options>

        @if (selectedOption()?.showWarningTransportSize) {
          <sd-system-message type="warning">
            <span class="transport-size-warning">
              возможен крупногабаритный транспорт
              <u (click)="openAddressModal()">указать ограничения проезда</u>
            </span>
          </sd-system-message>
        }
      }
    }
  }
}
